<!--乐刷人工申诉弹窗-->
<template>
  <div>
    <el-dialog :visible.sync="dialogVisible" title="人工申诉" width="500px" @close="$emit('update:dialogVisible', false)">
      <p class="topTips">人工申诉需要<span class="red">较长审核时间</span>，建议直接<br>
        <span class="link" @click="toOnlineAppeal">填写资料，在线申诉>></span></p>

      <p class="smallFont">若想进行人工申诉，请下载附件表格，
        填写并提交给乐刷工作人员审核。</p>
      <a class="file-download-button" href="static/乐刷申诉填写资料.xls" download><el-button type="primary">下载申诉表格</el-button></a>
      <el-button @click="confirmSubmit" :loading="loading">已通过人工渠道提交资料</el-button>
    </el-dialog>
  </div>
</template>

<script>
import qs from 'qs'
import { offlineCheck } from '@/api/risk'
export default {
  name: 'ArtificialAppeal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      dialogVisible: this.visible,
      loading: false
    }
  },
  watch: {
    visible (value) {
      this.dialogVisible = value
    }
  },
  methods: {
    /**
             * @description 确认通过人工渠道提交资料
             */
    confirmSubmit () {
      var that = this
      this.$confirm('确定已通过人工渠道提交资料给乐刷工作人员审核？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var data = {
          ticketNumber: that.row.fTicketNumber,
          merchantId: that.row.fMerchantId,
          riskSource: that.row.fRiskSource,
          offlineCheck: 1
        }
        that.loading = true
        data = qs.stringify(data)
        offlineCheck(data).then((data) => {
          that.loading = false
          if (parseInt(data.error_code) !== 0) {
            that.$message({
              showClose: true,
              message: data.error_msg,
              type: 'error'
            })
          } else {
            that.$message({
              showClose: true,
              message: data.error_msg,
              type: 'success'
            })
            that.dialogVisible = false
            that.$emit('update:dialogVisible', false)
          }
        }).catch(() => {
          that.loading = false
        })
      }).catch(() => {

      })
    },
    toOnlineAppeal () {
      var data = this.row
      this.$emit('toOnline', data)
    }
  }
}
</script>

<style scoped>
    .topTips{
        text-align: center;
        font-size: 17px;
        line-height: 25px;
    }
    .red{
        color:#F56C6C
    }
    .link{
        color:#409EFF;
        border-bottom: solid 1px #409EFF;
        cursor: pointer;
    }
</style>
